import { gql, useQuery, WatchQueryFetchPolicy } from '@apollo/client';
import { EqlField, ListMetricCriteriaInput, Query } from 'generated/graphql';
import { useMemo } from 'react';
import { useGetUser } from 'v2/core/services/user';

interface useFetchMeasuredAsCriteriaParams {
  field: EqlField | null;
  fetchPolicy?: WatchQueryFetchPolicy;
}

const LIST_METRIC_CRITERIA = gql`
  query listMetricCriteria($tenantID: ID!) {
    listMetricCriteria(request: { tenantID: $tenantID }) {
      fields {
        field
        displayName
        iconURL
        objectType
        valueType
        isMultiValue
        detail {
          metadata {
            source
            references {
              key
              displayName
              source
              iconURL
            }
          }
          reference {
            creatorName
            referenceID
            referenceType
            creatorID
          }
        }
      }
    }
  }
`;

export function useFetchMeasuredAsCriteria({
  field,
  fetchPolicy = 'cache-and-network',
}: useFetchMeasuredAsCriteriaParams) {
  const {
    tenant: { id: tenantID },
  } = useGetUser();

  const resp = useQuery<Query, ListMetricCriteriaInput>(LIST_METRIC_CRITERIA, {
    fetchPolicy,
    variables: {
      tenantID,
    },
  });

  const criteriaList = useMemo(() => {
    const fields = resp.data?.listMetricCriteria?.fields ?? [];

    if (!field) {
      return fields;
    }

    return [field, ...fields];
  }, [field, resp.data?.listMetricCriteria?.fields]);

  return { ...resp, criteriaList };
}
